import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router'
import { Environment } from '@core/constants'

const SentryConfig = () => {
    Sentry.init({
        dsn: Environment.SENTRY_DSN,
        environment: Environment.ENV,
        release: Environment.APP_VERSION,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [/^\//],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
    })
}

export default SentryConfig
